import { baseApi } from "api/BaseApi";
import { Option } from "api/common/types/common.types";

import { Organization, OrgStub } from "./orgs.types";

const ORGS_BASE_QUERY = "/org/organization";

export const orgsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    myOrg: builder.query<Organization, void>({
      query: () => `${ORGS_BASE_QUERY}/my_org/`,
      providesTags: ["MY_ORG"],
    }),
    getLabVendors: builder.query<Organization[], void>({
      query: () => `${ORGS_BASE_QUERY}/my_vendors/`,
    }),

    getOrgOptionsByOrgType: builder.query<Option[], string>({
      query: (type) => {
        return {
          url: `${ORGS_BASE_QUERY}/all_orgs_by_org_type/`,
          params: { type },
        };
      },
      transformResponse: (response: OrgStub[]) =>
        response.map((org) => ({
          label: org.name,
          value: org.org_id,
        })),
    }),
  }),

  overrideExisting: false,
});

export const {
  useMyOrgQuery,
  useGetLabVendorsQuery,
  useGetOrgOptionsByOrgTypeQuery,
} = orgsApi;
